import http from "@/shared/api/http";

export const getMyNotifications = async (skip = 0, take = 50) => {
  const res = await http.get('/notification', { params: { skip, take } });
  
  const data = res.data;
  const notifications = data?.value ?? data?.data ?? (Array.isArray(data) ? data : []);
  
  return notifications; 
}

export const getUnreadCount = async () => {
  const res = await http.get('/notification/unread-count');
  
  const data = res.data;
  const count = data?.value ?? data?.count ?? (typeof data === 'number' ? data : 0);
  
  return count; 
}

export const markAsRead = (id) => {
  return http.post(`/notification/${id}/mark-read`);
}